<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }" v-if="!registrationSuccessful">
            <form @submit.prevent="handleSubmit(register)" class="register-form" :class="{'loading': loading}">

                <h3 class="lead">Account</h3>
                <div class="row">
                    <ValidationProvider
                        :name="$t('First name')"
                        rules="required|min:3"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.first_name" type="text" name="first_name" :placeholder="$t('First name') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.first_name }">
                        <span class="text-danger">{{ errors[0] }}</span>

                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.first_name">
                            {{ registerFormErrors.first_name[0] }}
                        </div>

                    </ValidationProvider>

                    <ValidationProvider
                        :name="$t('Last name')"
                        rules="required"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.last_name" type="text" name="last_name" :placeholder="$t('Last name') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.last_name }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.last_name">
                            {{ registerFormErrors.last_name[0] }}
                        </div>
                    </ValidationProvider>
                </div>

                <div class="row">
                    <ValidationProvider
                        :name="$t('Phone')"
                        rules="required"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.phone" type="text" name="phone" :placeholder="$t('Phone') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.phone }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.phone">
                            {{ registerFormErrors.phone[0] }}
                        </div>
                    </ValidationProvider>

                    <ValidationProvider
                        :name="$t('E-mail')"
                        rules="required|email"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.email" type="text" name="email" :placeholder="$t('E-mail') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.email }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.email">
                            {{ registerFormErrors.email[0] }}
                        </div>
                    </ValidationProvider>
                </div>

                <div class="row">
                    <ValidationProvider
                        :name="$t('Password')"
                        rules="required|min:8"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }"
                        vid="password">

                        <input v-model="registerForm.password" type="password" name="password" :placeholder="$t('Password') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.password }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.password">
                            {{ registerFormErrors.password[0] }}
                        </div>
                    </ValidationProvider>

                    <ValidationProvider
                        :name="$t('Confirm password')"
                        rules="required|confirmed:password"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }"
                        vid="confirmation">

                        <input v-model="registerForm.password_confirmation" type="password" name="password_confirmation" :placeholder="$t('Confirm password')" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.password_confirmation }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.password_confirmation">
                            {{ registerFormErrors.password_confirmation[0] }}
                        </div>
                    </ValidationProvider>
                </div>

                <h3 class="lead">{{ $t('Company') }}</h3>

                <div class="row">
                    <ValidationProvider
                        :name="$t('Company')"
                        rules="required|min:3|max:200"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">
                        <input v-model="registerForm.name" type="text" name="name" :placeholder="$t('Company') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.name }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.name">
                            {{ registerFormErrors.name[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider
                        :name="$t('VAT no.')"
                        rules="max:200"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.ustid" type="text" name="name" :placeholder="$t('VAT no.')" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.ustid }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.ustid">
                            {{ registerFormErrors.ustid[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <div class="row">
                    <ValidationProvider
                        :name="$t('Street')"
                        rules="required|max:200"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.street" type="text" name="street" :placeholder="$t('Street') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.street }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.street">
                            {{ registerFormErrors.street[0] }}
                        </div>
                   </ValidationProvider>
                    <ValidationProvider
                        :name="$t('ZIP code')"
                        rules="required|numeric|max:50"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.zip_code" type="text" name="zip_code" :placeholder="$t('ZIP code') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.zip_code }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.zip_code">
                            {{ registerFormErrors.zip_code[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider
                        :name="$t('City')"
                        rules="required|max:100"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.city" type="text" name="city" :placeholder="$t('City') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.city }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.city">
                            {{ registerFormErrors.city[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider
                        :name="$t('Country')"
                        rules="required|max:100"
                        tag="div"
                        class="form-group col-sm-6"
                        v-slot="{ errors }">

                        <input v-model="registerForm.country" type="text" name="country" :placeholder="$t('Country') + '*'" class="form-control" :class="{ 'is-invalid': registerFormErrors && registerFormErrors.country }">
                        <span class="text-danger">{{ errors[0] }}</span>
                        <div class="alert alert-danger" v-if="registerFormErrors && registerFormErrors.country">
                            {{ registerFormErrors.country[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <google-re-captcha-v3
                    v-model="registerForm.gRecaptchaResponse"
                    ref="captcha"
                    site-key="6LcYc50aAAAAAEO4r8anAbWprxsv_cbDse5KqSMP"
                    id="sign_up_id"
                    inline
                    action="sign_up"
                ></google-re-captcha-v3>
                <button type="submit" class="btn btn-primary mt-2" :disabled="registerFormSubmitting">{{ $t('Register now') }}</button>
            </form>
            <div ></div>
        </ValidationObserver>
        <div v-else>
            <alert-success :message="registrationSuccessMessage"></alert-success>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GoogleReCaptchaV3 from '../../components/googlerecaptchav3/GoogleReCaptchaV3';

export default {
    components: {
        GoogleReCaptchaV3
    },
    data() {
        return {
            registerForm: {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                first_name: '',
                last_name: '',
                phone: '',
                street: '',
                zip_code: '',
                city: '',
                country: '',
                ustid: '',
                gRecaptchaResponse: null,
            },
            //mySiteKeyVariable: '6LcYc50aAAAAAEO4r8anAbWprxsv_cbDse5KqSMP',
            registerFormErrors: [],
            registerFormSubmitting: false,
            user: null,
            loading: false,
            captchaRef: null,
            registrationSuccessful: false,
            registrationSuccessMessage: this.$t('Your registration was successful.'),
        }
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            updateLoginStatus: 'auth/me',
        }),

        setCaptchaRef() {
            let captcha = this.$refs.captcha

            if (captcha && !this.captchaRef) {
                this.captchaRef = captcha;
            }
        },

        register() {
            this.setCaptchaRef();

            this.registerFormSubmitting = true;
            this.loading = true;

            axios.post('/api/register', this.registerForm)
                .then(response => {
                    this.updateLoginStatus();
                    this.loading = false;
                    this.$refs.captcha.execute();
                    // Redirect if on register page
                    this.registrationSuccessful = true;
                    if (this.$route.name === 'register') {
                        this.$router.push({ name: 'home' });
                    }
                }).catch( error => {
                    this.$refs.captcha.execute();
                    if (error.response.status === 422) { // Validation Error
                        this.registerFormErrors = error.response.data.errors;
                        this.registerFormSubmitting = false;
                    }
                    this.loading = false;
            });
        },

    },

    computed: {

        ...mapGetters({
            formErrors: 'auth/formErrors',
            authenticated: 'auth/authenticated',
            permissions: 'auth/permissions'
        }),

    }
}
</script>
